<template>
  <div class="panel panel-default" style="border: none;">
    <div class="form-group" v-if="!localProduct">
      <select-product-autocomplete></select-product-autocomplete>
    </div>
    <div class="form-control" v-if="localProduct">
        <input type="hidden" :name="'results[' + this.index + '][product_id]'" :value="localProduct.id">
        <a :href="`/cannabis-seeds/${localProduct.morph_domainable_attributes[0].slug}`" target="_blank" v-text="localProduct.name"></a>
        <a @click="remove()" class="btn btn-primary btn-danger btn-xs b-remove-pack__button remove-btn float-right">
          <i class="fa fa-ban"></i>
        </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-result",
  props: {
    product: Object,
    index: Number,
  },
  data () {
    return {
      localProduct: this.product
    }
  },
  created() {
    this.$root.$on('select-product-autocomplete:product_selected', this.onProductSelected);
  },
  methods: {
    onProductSelected(product) {
      this.localProduct = product;
    },
    remove() {
      this.localProduct = null;
    },
  },
}
</script>
